<template>
  <aha-modal
    title=""
    @hide="$emit('hide')"
  >
    <div class="gift">
      <img src="@/assets/images/trial/enjoy-trial.svg" alt="" width="340px">
      <h2 class="mb-4">
        {{ $i18nPresenter.t('Enjoy your One-month Free Trial!') }}
      </h2>
      <p>
        {{ $i18nPresenter.t('You now have access to our premium features.') }}
      </p>
    </div>
    <template #action>
      <aha-button @click="$emit('hide')" class="w-24">
        <span class="font-bold">{{ $i18nPresenter.t("Got it!") }}</span>
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  name: 'EnjoyTrialModal',

}
</script>

<style lang="scss" scoped>
.gift {
  img {
    margin: 0 auto;
    margin-bottom: 32px;
  }
}
</style>
